import React from 'react';
import { Avatar, Stack, Typography } from '@mui/material';
import { GetInvitationResponse } from '@localstack/types';
import { capitalise, formatDateTo } from '@localstack/services';

import { InvitationActionsDropdown } from './InvitationActionsDropdown';

export interface InvitationRowProps {
  invitation: GetInvitationResponse;
  canDeleteMembers: boolean;
  onResendInvitation?: (id: string) => Promise<void>;
  onRevokeInvitation: (id: string) => Promise<void>;
}

export const InvitationRow = ({
  invitation,
  canDeleteMembers,
  onResendInvitation,
  onRevokeInvitation,
}: InvitationRowProps): JSX.Element => (
  <React.Fragment>
    <Avatar
      alt={invitation.email}
      sx={{
        width: (theme) => theme.spacing(4),
        height: (theme) => theme.spacing(4),
        border: '1px dashed',
        borderColor: 'divider',
      }}
    >
      {invitation.email.charAt(0).toUpperCase()}
    </Avatar>
    <Stack direction="column">
      <Typography variant="caption">{invitation.email}</Typography>
    </Stack>
    <div />
    <Typography variant="caption">{capitalise(invitation.join_settings?.role ?? 'Member')} (Invited)</Typography>
    <Typography variant="caption">{formatDateTo(invitation.created, 'MMM D, YYYY')}</Typography>
    <InvitationActionsDropdown
      invitation={invitation}
      disabled={!canDeleteMembers}
      onResendInvitation={onResendInvitation}
      onRevokeInvitation={onRevokeInvitation}
    />
  </React.Fragment>
);
